import React from 'react';

/**
 * AIDesignerPanel component for GuiBuilder
 * AI-powered style and layout generator
 */
export default function AIDesignerPanel({
    targetUrl,
    setTargetUrl,
    aiPrompt,
    setAiPrompt,
    isGenerating,
    handleStartDesignJob,
    generationStatus,
    properties
}) {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                    <label style={{ fontSize: '0.75rem', fontWeight: 600, color: 'var(--text-secondary)' }}>
                        Extract Style from URL
                    </label>
                    <input
                        type="text"
                        className="input-field"
                        placeholder="https://example.com/product"
                        value={targetUrl}
                        onChange={e => setTargetUrl(e.target.value)}
                        style={{ fontSize: '0.8rem', padding: '0.5rem', margin: 0 }}
                        disabled={isGenerating}
                    />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                    <label style={{ fontSize: '0.75rem', fontWeight: 600, color: 'var(--text-secondary)' }}>
                        AI Custom Prompt
                    </label>
                    <textarea
                        className="textarea-field"
                        placeholder="e.g. Slate dark mode theme, font Outfit, circular buttons."
                        value={aiPrompt}
                        onChange={e => setAiPrompt(e.target.value)}
                        style={{ 
                            fontSize: '0.8rem', 
                            padding: '0.5rem', 
                            minHeight: '80px', 
                            margin: 0 
                        }}
                        disabled={isGenerating}
                    />
                </div>

                {isGenerating ? (
                    <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: '0.5rem',
                        padding: '0.75rem',
                        background: 'var(--bg-primary)',
                        borderRadius: '6px',
                        border: '1px solid var(--border)'
                    }}>
                        <i className="fa-solid fa-spinner fa-spin" style={{ color: '#2563eb' }}></i>
                        <span style={{ fontSize: '0.85rem', color: 'var(--text-secondary)' }}>
                            {generationStatus || 'Generating...'}
                        </span>
                    </div>
                ) : (
                    <button
                        onClick={handleStartDesignJob}
                        className="btn-primary"
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '0.5rem',
                            width: '100%',
                            padding: '0.75rem',
                            fontSize: '0.9rem',
                            fontWeight: 600,
                            background: 'var(--text-primary)',
                            color: 'var(--bg-primary)'
                        }}
                        disabled={!targetUrl && !aiPrompt}
                    >
                        <i className="fa-solid fa-wand-magic-sparkles"></i>
                        Generate Design
                    </button>
                )}

                <div style={{ 
                    borderTop: '1px solid var(--border)', 
                    paddingTop: '1rem' 
                }}>
                    <h4 style={{ 
                        fontSize: '0.8rem', 
                        fontWeight: 700, 
                        textTransform: 'uppercase', 
                        letterSpacing: '0.05em', 
                        color: 'var(--text-secondary)', 
                        margin: '0 0 0.75rem 0' 
                    }}>
                        Layout Template
                    </h4>
                    <select
                        className="input-field"
                        style={{ fontSize: '0.85rem', padding: '0.5rem', width: '100%' }}
                        value={properties.layoutTemplate || 'split-70-30'}
                        disabled={isGenerating}
                    >
                        <option value="split-70-30">70/30 Columns</option>
                        <option value="split-50-50">50/50 Columns</option>
                        <option value="split-30-70">30/70 Columns</option>
                        <option value="single-column">Single Column</option>
                    </select>
                    <p style={{ 
                        fontSize: '0.75rem', 
                        color: 'var(--text-secondary)', 
                        margin: '0.5rem 0 0 0',
                        lineHeight: 1.4
                    }}>
                        Choose the starting template for your configurator layout. The AI will adapt the scraped styles to this structure.
                    </p>
                </div>
            </div>
        </div>
    );
}
